import { ModernSearchHit, SearchDisplay } from "frontend/types";
import { useSearch } from "frontend/hooks/use-search";
import { ReactNode } from "react";

export function useCuratedTeases<T extends { title?: ReactNode | string }>(
  teasesCurated: Array<string>,
  createTease: (
    hit: ModernSearchHit | SearchDisplay,
    siteId?: string,
  ) => T | undefined,
  maxArticles?: number,
  siteId?: string,
): Array<T> | undefined {
  const ids = teasesCurated || [];
  const max = maxArticles || 4;

  const { data } = useSearch<ModernSearchHit>({
    index: "modern",
    query: ids.map((id) => `id:${id}`).join(" OR "),
    size: teasesCurated.length || 25,
  });

  /**
   * Sorting hits based on the order of IDs.
   */
  const sortedHits = data?.hits.toSorted((a, b) => {
    return ids.indexOf(a.id) - ids.indexOf(b.id);
  });

  if (!sortedHits || sortedHits.length === 0 || !siteId) return undefined;

  const teases: Array<T> = [];
  let counter = 0;
  const allTitles: Array<string> = [];

  /**  Only show 4 (or max) articles and filter out duplicates
   *   This is a temporary solution to filter out duplicates, as I had few issues with duplicate results when picking similar articles
   */
  sortedHits.forEach((item) => {
    if (counter < max) {
      const props = createTease(item, siteId);
      if (!props) return;
      const title = props.title?.toString();
      if (title && !allTitles.includes(title)) {
        teases.push(props);
        allTitles.push(title);
        counter++;
      }
    }
  });

  return teases.length > 0 ? teases : undefined;
}
